import { render, staticRenderFns } from "./DefaultCrudView.vue?vue&type=template&id=4f1cceb5&scoped=true"
import script from "./DefaultCrudView.vue?vue&type=script&lang=js"
export * from "./DefaultCrudView.vue?vue&type=script&lang=js"
import style0 from "./DefaultCrudView.vue?vue&type=style&index=0&id=4f1cceb5&prod&lang=scss&scoped=true"
import style1 from "./DefaultCrudView.vue?vue&type=style&index=1&id=4f1cceb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cceb5",
  null
  
)

export default component.exports